import PropTypes from 'prop-types';
import React from 'react';

function ElementVideo({ url, title, type, className, wrapperClassName }) {
  const video = (
    <video autoPlay muted loop title={title} className={className}>
      <source src={url} type={type} />
    </video>
  );

  return wrapperClassName ? <div className={wrapperClassName}>{video}</div> : video;
}

ElementVideo.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
};

ElementVideo.defaultProps = {
  title: '',
  wrapperClassName: null,
};

export default ElementVideo;
